<div
  class="image-preview-trigger"
  role="button"
  tabindex="0"
  (click)="open(0); $event.stopPropagation()"
  (keydown.enter)="open(0); $event.stopPropagation()"
  (keydown.space)="open(0); $event.preventDefault()"
>
  <ng-content />
</div>

<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: '52rem', maxWidth: '95vw' }"
  [contentStyle]="{ overflow: 'hidden', padding: '0' }"
  styleClass="image-preview-dialog"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="image-preview-dialog-header">
      @if (title()) {
      <h2 class="image-preview-dialog-title">{{ title() }}</h2>
      } @if (subheadingTemplate(); as subheading) {
      <div class="image-preview-dialog-subheading">
        <ng-container [ngTemplateOutlet]="subheading" />
      </div>
      }
    </div>
  </ng-template>

  <div class="image-preview-galleria-wrapper">
    <p-galleria
      [value]="images()"
      [activeIndex]="activeIndex()"
      (activeIndexChange)="onActiveIndexChange($event)"
      [showIndicators]="true"
      [showThumbnails]="false"
      [showThumbnailNavigators]="false"
      [showItemNavigators]="images().length > 1"
      [circular]="true"
      [containerStyle]="{ width: '100%', border: 'none' }"
    >
      <ng-template #item let-item>
        <img [src]="item.itemImageSrc" [alt]="item.alt ?? ''" class="image-preview-galleria-image" />
      </ng-template>
      @if (showThumbnails()) {
      <ng-template #thumbnail let-item>
        <img [src]="item.thumbnailImageSrc" [alt]="item.alt ?? ''" class="image-preview-galleria-thumbnail" />
      </ng-template>
      }
    </p-galleria>
  </div>
</p-dialog>
